// Explore's Community route type, activities and features filters match community_feed
// fields that only exist once typesense:add_community_feed_filter_fields and
// typesense:upsert_community_feed have run; until then every pick would match nothing.
// Rails publishes AppSetting.community_feed_tag_filters_enabled? (switched on by the
// upsert) as window.communityFeedTagFiltersEnabled. See CommunityFeedFilterFields.
export function communityTagFiltersEnabled(flags: { communityFeedTagFiltersEnabled?: unknown } = window): boolean {
  return flags.communityFeedTagFiltersEnabled === true;
}
